import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Form,
  Input,
  Select,
  Checkbox,
  Button,
  Upload,
  Row,
  Col,
  Breadcrumb,
  message,
  InputNumber,
} from "antd";
import moment from "moment";

import Main from "../../components/layout/Main";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import UploadIcon from "../../assets/images/upload-image.svg";
import { ChevronDown } from "lucide-react";
import { auctionsAPI } from "../../services/api";
import { Severty, ShowToast } from "../../helper/toast";

const { TextArea } = Input;
const { Option } = Select;
const CreateAuction = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileError, setFileError] = useState(null);

  const handleChange = (value) => {
    console.log("Selected value:", value);
  };

  // Handle file upload
  // const handleFileChange = ({ fileList: newFileList }) => {
  //   const allowedTypes = [
  //     "image/jpeg",
  //     "image/jpg",
  //     "image/png",
  //     "image/svg+xml",
  //   ];

  //   const MAX_SIZE_MB = 2;
  //   const validFiles = [];

  //   newFileList.forEach((file) => {
  //     // ✅ File type validation
  //     if (!allowedTypes.includes(file.type)) {
  //       setFileError("Only JPG, JPEG, PNG, and SVG files are allowed!");
  //       return;
  //     }

  //     // ✅ File size validation
  //     if (file.size / 1024 / 1024 > MAX_SIZE_MB) {
  //       setFileError("File must be smaller than 2MB!");
  //       return;
  //     }

  //     validFiles.push(file);
  //     // ✅ Update state with valid files only
  //     setFileList(validFiles);

  //     // ✅ Clear error if valid upload
  //     if (validFiles.length > 0) {
  //       setFileError("");
  //     }
  //   });
  // };
  const handleFileChange = ({ fileList: newFileList }) => {
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/svg+xml",
    ];
    const MAX_SIZE_MB = 2;

    const filtered = newFileList.filter((file) => {
      const real = file.originFileObj;
      if (!real) return false;

      if (!allowedTypes.includes(real.type)) {
        setFileError("Only JPG, JPEG, PNG, and SVG files are allowed!");
        return false;
      }

      if (real.size / 1024 / 1024 > MAX_SIZE_MB) {
        setFileError("File must be smaller than 2MB!");
        return false;
      }

      return true;
    });

    setFileList(filtered); // ✅ update local state
    form.setFieldsValue({ images: filtered }); // ✅ sync with form

    if (filtered.length > 0) {
      setFileError("");
    }
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      // Generate dates using moment.js
      const startDate = moment().toISOString(); // Current date
      const endDate = moment().add(7, "days").toISOString(); // 7 days from now

      // Prepare form data
      const formData = {
        itemName: values.itemName,
        itemDescription: values.itemDescription,
        startDate: startDate,
        endDate: endDate,
        insuranceFee: values.insuranceFee,
        startPrice: values.startPrice,
        sellPrice: values.sellPrice,
        termsAndConditions: values.termsAndConditions,
        images: fileList.map((file) => file.originFileObj).filter(Boolean),
      };

      // Call API
      const response = await auctionsAPI.createAuction(formData);
      if (response.status === 200) {
        ShowToast(response.message, Severty.SUCCESS);
        navigate("/auctions");
      }
      // ShowToast("Auction created successfully!", Severty.SUCCESS);
    } catch (error) {
      console.error("Error creating auction:", error);
      ShowToast(
        error.message || "Failed to create auction. Please try again.",
        Severty.ERROR
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <Main>
      <Breadcrumb
        className="for-route-path-head"
        separator={<img src={BreadcrumbArrow} alt=">" />}
      >
        <Breadcrumb.Item
          onClick={() => navigate("/auctions")}
          style={{ cursor: "pointer" }}
        >
          Auctions
        </Breadcrumb.Item>
        <Breadcrumb.Item>Create Auction</Breadcrumb.Item>
      </Breadcrumb>
      <div className="create-auction-page">
        <div className="form-container">
          <Row>
            <Col span={24} md={10}>
              <Form
                form={form}
                layout="vertical"
                className="auction-form"
                onFinish={handleSubmit}
              >
                {/* Upload Area */}
                <Form.Item
                  name="images"
                  label="Item Images"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e.fileList}
                  rules={[
                    {
                      required: true,
                      message: "Please upload at least one image!",
                    },
                  ]}
                >
                  <Upload.Dragger
                    multiple
                    className="custom-upload-box"
                    showUploadList={true}
                    fileList={fileList}
                    onChange={handleFileChange}
                    beforeUpload={() => false} // Prevent auto upload
                    accept=".png, .jpg, .jpeg, .svg"
                  >
                    <div className="upload-inner-content">
                      <img
                        src={UploadIcon}
                        alt="upload"
                        className="upload-icon"
                      />
                      <p className="upload-text">
                        More than 1 Image is allowed
                      </p>
                    </div>
                  </Upload.Dragger>

                  {fileError && (
                    <p className="profile-file-error" style={{ color: "red" }}>
                      {fileError}
                    </p>
                  )}
                </Form.Item>

                <Form.Item
                  label="Item Name"
                  name="itemName"
                  rules={[
                    {
                      required: true,
                      validator: (_, values) => {
                        if (!values || !values.trim()) {
                          return Promise.reject(
                            new Error("Please enter item name!")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input placeholder="Enter item name" />
                </Form.Item>

                <Form.Item
                  label="Item Description"
                  name="itemDescription"
                  rules={[
                    {
                      required: true,
                      validator: (_, values) => {
                        if (!values || !values.trim()) {
                          return Promise.reject(
                            new Error("Please enter description")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <TextArea
                    rows={4}
                    placeholder="Describe your item..."
                    style={{ color: "white" }}
                  />
                </Form.Item>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Insurance Fee ($)"
                      name="insuranceFee"
                      rules={[
                        {
                          required: true,
                          validator: (_, values) => {
                            if (!values || !values.trim()) {
                              return Promise.reject(
                                new Error("Please enter insuarance fee")
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter insurance fee"
                        style={{ width: "100%" }}
                        min={0}
                        precision={2}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Starting Price ($)"
                      name="startPrice"
                      rules={[
                        {
                          required: true,
                          validator: (_, values) => {
                            if (!values || !values.trim()) {
                              return Promise.reject(
                                new Error("Please enter starting price")
                              );
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        placeholder="Enter starting price"
                        style={{ width: "100%" }}
                        min={0}
                        precision={2}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  label="Selling Price ($)"
                  name="sellPrice"
                  rules={[
                    {
                      required: true,
                      validator: (_, values) => {
                        if (!values || !values.trim()) {
                          return Promise.reject(
                            new Error("Please enter selling price")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter selling price"
                    style={{ width: "100%" }}
                    min={0}
                  />
                </Form.Item>

                {/* <Form.Item
                  label="Terms and Conditions"
                  name="termsAndConditions"
                  rules={[
                    {
                      required: true,
                      message: "Please enter terms and conditions!",
                    },
                  ]}
                >
                  <TextArea
                    rows={3}
                    placeholder="Enter terms and conditions..."
                  />
                </Form.Item> */}

                <Form.Item
                  name="agreement"
                  valuePropName="checked"
                  rules={[
                    { required: true, message: "Accept aggrement required" },
                  ]}
                >
                  <Checkbox className="custom-checkbox">
                    <span className="custom-checkbox-content">
                      I agree to the Terms & Conditions and understand that my
                      item requires admin approval before listing
                    </span>
                  </Checkbox>
                </Form.Item>

                <Form.Item>
                  <Button
                    type="default"
                    htmlType="submit"
                    className="Fill-button"
                    loading={loading}
                    disabled={loading}
                  >
                    Submit for Review
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </div>
    </Main>
  );
};

export default CreateAuction;
